import '../style.scss'
import { useContext, useEffect, useState } from "react";
import { 
    AppSpan, Button, CenterPopupContainer,
    CustomContainer, FixedContainer, FlexRow, ScreenTitle 
} from "src/style"
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { NewUserLayout } from 'src/component'
import { BsEye, BsEyeSlash } from 'react-icons/bs';

export const NewUserSetupCompletion: React.FC<any> = ({close}) => {
    const { info: {userCreationProcess}, setInfoProperty } = useContext(AppInfoContext)
    const [hidePassword, setHidePassword] = useState(true)

    async function handleNext() {
        await setInfoProperty('userCreationProcess', {
            userBasics: false,
            userRole: false,
            setupSummary: false
        })

        close()
    }

    return (
        <>
            <CenterPopupContainer onClick={close} />
            <FixedContainer
                top="50" tSizeUnit="%" 
                left="50" lSizeUnit="%"
                bgColor="#ffffff" zIndex='9'
                height='82.6' width='123.6'
                radius='0.8'
                className="popup-container-lg"
            >
                <NewUserLayout currentScreen='user-basics'>
                    <CustomContainer bottomMargin="2.5">
                        <ScreenTitle 
                            textSize="2" color="#111111" 
                            fontWeight="600"
                        >
                            {userCreationProcess?.firstName} has been added as an Admin
                        </ScreenTitle>
                        <AppSpan textSize="1.6" color="#4F4F4F">
                            {userCreationProcess?.firstName} will now appear in your list of Active admin users.
                        </AppSpan>
                    </CustomContainer>
                    <CustomContainer topMargin="6">
                        <AppSpan 
                            textSize="1.6" color="#111111" 
                            fontWeight="700"
                        >
                            User Details
                        </AppSpan>
                        <CustomContainer>
                            <FlexRow gap="1" topMargin="1" wrap="wrap">
                                <AppSpan textSize="1.6" color="#4F4F4F">
                                    Display name:
                                </AppSpan>
                                <AppSpan textSize="1.6" color="#4F4F4F">
                                    {userCreationProcess?.firstName} {userCreationProcess?.lastName}
                                </AppSpan>
                            </FlexRow>
                            <FlexRow 
                                gap="1" topMargin="1" 
                                bottomMargin="1" wrap="wrap"
                            >
                                <AppSpan textSize="1.6" color="#4F4F4F">
                                    Username:
                                </AppSpan>
                                <AppSpan textSize="1.6" color="#4F4F4F">
                                    {userCreationProcess?.email}
                                </AppSpan>
                            </FlexRow>
                            <FlexRow gap="1" topMargin="1" wrap="wrap">
                                <AppSpan textSize="1.6" color="#4F4F4F">
                                    Password details:
                                </AppSpan>
                                <FlexRow width="auto" sizeUnit="" gap="1">
                                    <AppSpan 
                                        textSize="1.6" color="#4F4F4F"
                                        topMargin={hidePassword ? '0.5' : '0'}
                                    >
                                        {hidePassword ? '***********' : userCreationProcess?.password}
                                    </AppSpan>
                                    { hidePassword ?
                                        <BsEye 
                                            fontSize='1.8rem'
                                            onClick={() => setHidePassword(!hidePassword)}
                                        />
                                        :
                                        <BsEyeSlash 
                                            fontSize='1.8rem' 
                                            onClick={() => setHidePassword(!hidePassword)}
                                        />
                                    }
                                </FlexRow>
                            </FlexRow>
                            <FlexRow 
                                gap="1" topMargin="1" 
                                bottomMargin="1" wrap="wrap"
                            >
                                <AppSpan textSize="1.6" color="#4F4F4F">
                                    Send to:
                                </AppSpan>
                                <AppSpan textSize="1.6" color="#4F4F4F">
                                    {userCreationProcess?.email}
                                </AppSpan>
                            </FlexRow>
                        </CustomContainer>
                    </CustomContainer>
                    <FlexRow justifyContent="flex-end">
                        <Button 
                            width='15.4' 
                            hoverBgColor='#ffffff' 
                            hoverColor='#5627FF'
                            borderColor='#5627FF'
                            topMargin="5"
                            onClick={handleNext}
                        >
                            Close
                        </Button>
                    </FlexRow>
                </NewUserLayout>
            </FixedContainer>
        </>
    )
}